var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationStatus } from '../enums/enums';
import { InvisibleReCaptchaComponent } from '../../../../node_modules/ngx-captcha';
var AuthChangePasswordComponent = /** @class */ (function (_super) {
    __extends(AuthChangePasswordComponent, _super);
    function AuthChangePasswordComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showCaptcha = false;
        _this._countTimes = 0;
        _this._captchaResponse = null;
        _this._captchaReady = false;
        return _this;
    }
    AuthChangePasswordComponent.prototype.ngOnInit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2109' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2109 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        sessionStorage.setItem("currentWindow", "עדכן את הסיסמה שלך");
        sessionStorage.setItem("elasticCode", "2189");
    };
    AuthChangePasswordComponent.prototype.captchaSuccess = function (captchaResponse) {
        this._captchaResponse = captchaResponse;
        this.callServer();
    };
    AuthChangePasswordComponent.prototype.captchaReady = function () {
        this._captchaReady = true;
    };
    AuthChangePasswordComponent.prototype.submit = function (form) {
        this._form = form;
        debugger;
        var controls = this.inputsQuery.map(function (elm) { return elm; });
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element && controls.length > 2) {
            if (controls[1].ngControl.errors.pattern) {
                element = controls[1].elementRef.nativeElement;
            }
            else if (controls[1].ngControl.errors.required == null) {
                element = controls[2].elementRef.nativeElement;
            }
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            this.serverError = null;
            if (this._captchaReady) {
                this.captchaElem.execute();
            }
            else {
                this.callServer();
            }
        }
        this.buildFormAccessibility();
    };
    AuthChangePasswordComponent.prototype.callServer = function () {
        var _this = this;
        this.authUserService.sendAuthData("ChangePassword", { Password: this._form.value.pwOld, NewPassword: this._form.value.pwNew, captchaResponse: this._captchaResponse })
            .subscribe(function (res) {
            if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidPassword") {
                _this.serverError = "יש להקליד סיסמא המכילה 7-15 אותיות לועזיות קטנות, גדולות, מספרים. על הסיסמא להכיל לפחות תו אחד מכל סוג, ולא הייתה בשימוש ב-10 הסיסמאות הקודמות שלך.";
                if (_this.captchaElem != null && _this.showCaptcha) {
                    _this.captchaElem.resetCaptcha();
                }
                if (_this._countTimes == 8) {
                    _this.showCaptcha = true;
                }
                else {
                    _this._countTimes++;
                }
                var elements_1 = _this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; });
                if (elements_1 && elements_1.length > 0) {
                    elements_1[0].setAttribute('aria-invalid', true);
                    setTimeout(function () { return elements_1[0].focus(); }, 0);
                }
            }
            else if (res.Details.UserInputError == "ReCaptchaInvalid") {
                _this.captchaElem.resetCaptcha();
                _this.serverError = "הקאפצ'ה נכשלה";
            }
            else {
                _this.modalService.close(res.Details);
            }
        }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
    };
    return AuthChangePasswordComponent;
}(AuthBaseComponent));
export { AuthChangePasswordComponent };
